<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">edit</i>
                        </div>
                        <h4 class="card-title ">Editar</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group is-filled"
                                         v-bind:class="{'has-danger' : validation.manufacturer_id != '' }">
                                        <label for="manufacturer_id" class="bmd-label-floating">Fabricante *</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="manufacturers"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.manufacturer_id"
                                            placeholder="Escolha um fabricante">
                                        </model-list-select>
                                        <label v-if="validation.manufacturer_id != ''" id="manufacturer_id-error" class="error" for="manufacturer_id">{{ validation.manufacturer_id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.code != '', 'has-danger' : validation.code != '' }">
                                        <label for="code" class="bmd-label-floating">Código *</label>
                                        <input v-numeric-only refs="code" type="text" class="form-control" v-model="form.code" />
                                        <label v-if="validation.code != ''" id="code-error" class="error" for="code">{{ validation.code }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                :to-back="{name: 'models.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {
            form: {
                set(_item) {

                },
                get() {
                    return this.$store.state.models.item;
                }
            },
            manufacturers: {
                set(_manufacturers) {

                },
                get() {
                    return this.$store.state.manufacturers.itens;
                }
            }
        },
        created() {
            this.getDataManufacturers();
        },
        data() {
            return {
                validation: {
                    code: '',
                    manufacturer_id: '',
                    name: ''
                }
            };
        },
        methods: {
            async getDataManufacturers() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('manufacturers/all');

                response.then(function () {
                    self.getData();
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            onSubmit(_ev) {
                var valid = true;
                var self = this;

                self.validation.name = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');

                    const response = self.$store.dispatch('models/edit', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Modelo atualizado com sucesso!");
                        self.$router.push({'name': 'models.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            },
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('models/get', this.$route.params.id);

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.$router.push({'name': 'models.index'});
                });
            }
        }
    };
</script>